import React, { useEffect } from "react";
import { connect } from "react-redux";
import DisplayHouses from "./DisplayHouses";
import NoHouses from "./NoHouses";
import AddHouses from "./AddHouses";
import { app } from "../../constants/config";
import { fetchingHouses } from "../../actions/houseActions";

const Houses = (props) => {
  useEffect(() => {
    FetchHouses();
  }, []);

  const FetchHouses = () => {
    fetch(`${app}/house/get`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${props.banker.token}`,
      },
      body: JSON.stringify({
        fromDate: new Date(
          new Date().getFullYear(),
          new Date().getMonth(),
          1
        ).getTime(),
        toDate:
          new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          ).getTime() +
          1000 *
            60 *
            60 *
            24 *
            new Date(
              new Date().getFullYear(),
              new Date().getMonth(),
              0
            ).getDate(),
        month: `${new Date().getFullYear()}-${(
          "0" +
          (new Date().getMonth() + 1)
        ).slice(-2)}`,
      }),
    })
      .then((res) => res.json())
      .then((details) => {
        if (details.code == 2) {
        } else {
          props.fetchingHouses(details);
        }
      })
      .catch((err) => {});
  };

  const Status = props.Houses.length > 0 ? <DisplayHouses /> : <NoHouses />;

  return (
    <>
      <AddHouses></AddHouses>
      {Status}
    </>
  );
};
const mapStateToProps = (state) => ({
  Houses: state.House.Houses,
  banker: state.auth.banker,
});

export default connect(mapStateToProps, { fetchingHouses })(Houses);
